window.addEventListener("globoFilterRenderCompleted", function () {
    const swatchBtns = document.querySelectorAll(".spf-product__swatch");
    swatchBtns.forEach(btn => {
        btn.addEventListener("click", function () {
            const productCard = this.closest(".spf-product-card");
            setTimeout(()=>{
              const spfInput = productCard.querySelector(".spf-input");
                const link = productCard.querySelector(".spf-link");
                const url = new URL(link.href);
                const variantValue = url.searchParams.get("variant");
                  if (variantValue) {
                  spfInput.value = variantValue;
                }
              
            }, 100)
            
        });
    });
});